<template>
  <sui-form @submit="clickContinue">
    <sui-form-fields fields="two">
      <sui-form-field>
        <img src="@/assets/img/voucher.png" alt="Voucher-Image" />
      </sui-form-field>
      <sui-form-field>
        <sui-table>
          <sui-table-header>
            <sui-table-row>
              <sui-table-headerCell>{{ $t('labelAmount') }}</sui-table-headerCell>
              <sui-table-headerCell>{{ $t('labelName') }}</sui-table-headerCell>
              <sui-table-headerCell>{{ $t('labelPrice') }}</sui-table-headerCell>
            </sui-table-row>
          </sui-table-header>
          <sui-table-body>
            <sui-table-row>
              <sui-table-cell>1x</sui-table-cell>
              <sui-table-cell>{{ $t($store.getters.currentVoucher.name) }}</sui-table-cell>
              <sui-table-cell><i18n-n :value="$store.getters.currentVoucher.price/100" format="currency" locale="de-DE"></i18n-n></sui-table-cell>
            </sui-table-row>
          </sui-table-body>
        </sui-table>
      </sui-form-field>
    </sui-form-fields>

    <sui-header dividing>{{ $t('labelMail') }}</sui-header>
    <sui-form-field required :error="error.mail">
      <label>{{ $t('labelMailAdress') }}</label>
      <input name="mail" type="text" placeholder="max@mustermann.de" v-model="current.mail" @change="validateEmail" v-on:keyup.enter="keyEnter('smsEnable')">
      <sui-message error :visible="error.mail">
        <p>{{ $t('labelMailAdress') }} {{ $t('errorUncorrect') }}</p>
      </sui-message>
    </sui-form-field>

    <sui-header dividing>{{ $t('labelSMS') }}</sui-header>
    <sui-form-fields fields="three">
      <sui-form-field>
        <label>{{ $t('labelSubmitSMS') }}</label>

        <sui-dropdown id="smsEnable" selection :options="lists.smsEnable" v-model="current.smsEnable" />
      </sui-form-field>
      <sui-form-field>
        <label>{{ $t('labelPhonePre') }}</label>
        <sui-dropdown search selection :options="lists.smsPrefix" v-model="current.smsPrefix" />
      </sui-form-field>
      <sui-form-field>
        <label>{{ $t('labelPhoneNo') }}:</label>
        <input name="smsValue" type="text" placeholder="0176/12345678" v-model="current.smsValue" />
      </sui-form-field>
    </sui-form-fields>

    <sui-header dividing>{{ $t('labelInvoiceDetails') }}</sui-header>
    <sui-form-field>
      <label>{{ $t('labelCompany') }}:</label>
      <input name="company" type="text" placeholder="Mustermann GmbH" v-model="current.company" />
    </sui-form-field>
    <sui-form-fields fields="two">
      <sui-form-field required :error="error.firstName">
        <label>{{ $t('labelFirstName') }}:</label>
        <input name="firstName" type="text" placeholder="Max" v-model="current.firstName" @change="validateFirstname" />
        <sui-message error :visible="error.firstName">
          <p>{{ $t('labelFirstName') }} {{ $t('errorEmpty') }}</p>
        </sui-message>
      </sui-form-field>
      <sui-form-field required :error="error.lastName">
        <label>{{ $t('labelLastName') }}:</label>
        <input name="lastName" type="text" placeholder="Mustermann" v-model="current.lastName" @change="validateLastName" />
        <sui-message error :visible="error.lastName">
          <p>{{ $t('labelLastName') }} {{ $t('errorEmpty') }}</p>
        </sui-message>
      </sui-form-field>
    </sui-form-fields>
    <sui-form-fields fields="three">
      <sui-form-field required :error="error.street">
        <label>{{ $t('labelStreet') }} + {{ $t('labelHouseNo') }}:</label>
        <input name="street" type="text" placeholder="Musterstr. 123" v-model="current.street" @change="validateStreet" />
        <sui-message error :visible="error.street">
          <p>{{ $t('labelStreet') }} {{ $t('errorEmpty') }}</p>
        </sui-message>
      </sui-form-field>
      <sui-form-field required :error="error.zip">
        <label>{{ $t('labelZip') }}:</label>
        <input name="zip" type="text" placeholder="12345" v-model="current.zip" @change="validateZip" />
        <sui-message error :visible="error.zip">
          <p>{{ $t('labelZip') }} {{ $t('errorEmpty') }}</p>
        </sui-message>
      </sui-form-field>
      <sui-form-field required :error="error.city">
        <label>{{ $t('labelCity') }}:</label>
        <input name="city" type="text" placeholder="Musterhausen" v-model="current.city" @change="validateCity" />
        <sui-message error :visible="error.city">
          <p>{{ $t('labelCity') }} {{ $t('errorEmpty') }}</p>
        </sui-message>
      </sui-form-field>
    </sui-form-fields>
    <sui-divider />
    <sui-form-field required :error="error.agb">
      <div class="ui checkbox">
        <input name="acceptConditions" type="checkbox" v-model="current.acceptConditions">
        <i18n path="labelAcceptCondition" tag="label">
          <template v-slot:linkConditions>
            <a @click="openModal('modalConditions')">{{ $t('labelConditions') }}</a>
          </template>
          <template v-slot:linkWithdrawal>
            <a @click="openModal('modalWithdrawal')">{{ $t('strWithdrawal') }}</a>
          </template>
        </i18n>
      </div>
    </sui-form-field>
    <sui-form-field required :error="error.privacy">
      <div class="ui checkbox">
        <input name="acceptPrivacy" type="checkbox" v-model="current.acceptPrivacy">
        <i18n path="labelAcceptPrivacy" tag="label">
          <template v-slot:linkPrivacy>
            <a @click="openModal('modalPrivacy')">{{ $t('strPrivacy') }}</a>
          </template>
        </i18n>
      </div>
    </sui-form-field>
    <div class="ui fluid buttons">
      <sui-button @click.prevent="clickBack">{{ $t('btnBack') }}</sui-button>
      <sui-button @click.prevent="clickContinue" color="red">{{ $t('btnContinue') }}</sui-button>
    </div>
    <Modal :content="modalContent" :open="modalOpen" v-on:closeModal="closeModal"></Modal>
  </sui-form>
</template>

<script>
  import StorageService from '@/services/StorageService.js';
  import Modal from '@/views/components/Modal.vue';
  export default {
    name: 'BuyForm',
    props: ['current'],
    components: {
      Modal,
      StorageService
    },
    data() {
      return {
        modalOpen: false,
        modalContent: 'dd',
        error: {
          mail: false,
          firstName: false,
          lastName: false,
          street: false,
          zip: false,
          city: false,
          agb: false,
          privacy: false
        },
        lists: {
          smsEnable: [
            { text: 'Nein', value: 0 },
            { text: 'Ja', value: 1 },
          ],
          smsPrefix: [
            { value: '+49', flag: 'de', text: 'Deutschland (+49)' },
            { value: '+43', flag: 'at', text: 'Östereich (+43)' },
            { value: '+41', flag: 'ch', text: 'Schweiz (+41)' },
            { value: '+32', flag: 'be', text: 'Belgien (+32)' },
            { value: '+45', flag: 'dk', text: 'Dänemark (+45)' },
            { value: '+34', flag: 'es', text: 'Spanien (+34)' },
            { value: '+33', flag: 'fr', text: 'Frankreich (+33)' },
            { value: '+423', flag: 'li', text: 'Liechtenstein (+423)' },
            { value: '+44', flag: 'gb', text: 'England (+44)' },
            { value: '+39', flag: 'it', text: 'Italien (+39)' },
            { value: '+352', flag: 'lu', text: 'Luxemburg (+352)' },
            { value: '+47', flag: 'no', text: 'Norwegen (+47)' },
            { value: '+31', flag: 'nl', text: 'Niederlande (+31)' },
            { value: '+46', flag: 'sh', text: 'Schweden (+46)' },
            { value: '+1', flag: 'us', text: 'USA (+1)' },
          ]
        }
      }
    },
    methods: {
      openModal(modalName) {
        this.modalContent = modalName
        this.modalOpen = true
      },
      closeModal() {
        this.modalOpen = false
      },
      keyEnter(next,event) {
        event.preventDefault()
        document.getElementById(next).focus();
      },
      clickBack() {
        this.$router.push('/')
      },
      clickContinue() {
        this.validateEmail()
        this.validateFirstname()
        this.validateLastName()
        this.validateStreet()
        this.validateZip()
        this.validateCity()
        this.validateTerms()
        if (
          this.error.mail == false &&
          this.error.firstName == false &&
          this.error.lastName == false &&
          this.error.street == false &&
          this.error.zip == false &&
          this.error.city == false &&
          this.error.agb == false &&
          this.error.privacy == false
        ) {
          this.track();
          this.$emit('goNext')
        }
      },
      validateEmail() {
        let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        this.error.mail = !(this.current.mail != '' && reg.test(this.current.mail))
      },
      validateFirstname() {
        this.error.firstName = !(this.current.firstName && this.current.firstName.length > 0)
      },
      validateLastName() {
        this.error.lastName = !(this.current.lastName && this.current.lastName.length > 0)
      },
      validateStreet() {
        this.error.street = !(this.current.street && this.current.street.length > 0)
      },
      validateZip() {
        this.error.zip = !(this.current.zip && this.current.zip.length > 0)
      },
      validateCity() {
        this.error.city = !(this.current.city && this.current.city.length > 0)
      },
      validateTerms() {
        this.error.agb = this.current.acceptConditions == 0
        this.error.privacy = this.current.acceptPrivacy == 0
      },
      track() {
        if (StorageService.isCookieStatisticsAccepted()) {
          this.$gtag.query('event', 'begin_checkout', {
            "items": [ {
                "id": this.$store.getters.currentVoucher.id,
                "name": this.$store.getters.currentVoucher.name,
                "quantity": 1,
                "price": (this.$store.getters.currentVoucher.price/100),
              }],
            "coupon": ""
          })
        }
      }
    }

  }</script>

<style lang="scss" scoped>
  a{
      cursor: pointer
  }
</style>
